import { IPublicClientApplication } from '@azure/msal-browser';
import { dvList, dvCreate, dvDelete } from '../api/dataverseClient';
import { Dependency, DependencyType } from '../types';

const DEP_FIELDS = [
  'dagrun_pm_dependencyid',
  'dagrun_pm_dependencytype',
  'dagrun_pm_lagdays',
  '_dagrun_pm_predecessortaskid_value',
  '_dagrun_pm_successortaskid_value',
  '_dagrun_pm_projectid_value',
];

export async function getProjectDependencies(
  pca: IPublicClientApplication,
  projectId: string,
): Promise<Dependency[]> {
  return dvList<Dependency>(pca, 'dagrun_pm_dependencies', {
    select: DEP_FIELDS,
    filter: `_dagrun_pm_projectid_value eq ${projectId}`,
  });
}

// Dependencies touching a specific task — as predecessor OR successor.
export async function getTaskDependencies(
  pca: IPublicClientApplication,
  taskId: string,
): Promise<Dependency[]> {
  return dvList<Dependency>(pca, 'dagrun_pm_dependencies', {
    select: DEP_FIELDS,
    filter: `_dagrun_pm_predecessortaskid_value eq ${taskId} or _dagrun_pm_successortaskid_value eq ${taskId}`,
  });
}

export interface CreateDependencyInput {
  projectId: string;
  predecessorTaskId: string;
  successorTaskId: string;
  dependencyType: number;
  lagDays?: number | null;
}

export async function createDependency(
  pca: IPublicClientApplication,
  inp: CreateDependencyInput,
): Promise<string> {
  const data: Record<string, unknown> = {
    dagrun_pm_dependencytype: inp.dependencyType,
    'dagrun_pm_projectid@odata.bind': `/dagrun_pm_projects(${inp.projectId})`,
    'dagrun_pm_predecessortaskid@odata.bind': `/dagrun_pm_tasks(${inp.predecessorTaskId})`,
    'dagrun_pm_successortaskid@odata.bind': `/dagrun_pm_tasks(${inp.successorTaskId})`,
  };
  if (inp.lagDays != null) data.dagrun_pm_lagdays = inp.lagDays;
  return dvCreate(pca, 'dagrun_pm_dependencies', data);
}

export async function deleteDependency(
  pca: IPublicClientApplication,
  dependencyId: string,
): Promise<void> {
  return dvDelete(pca, 'dagrun_pm_dependencies', dependencyId);
}

// Only FS dependencies render as arrows in v1. Helper kept here for clarity.
export const isFS = (d: Dependency) => d.dagrun_pm_dependencytype === DependencyType.FS;

export const DEPENDENCY_TYPE_LABEL: Record<number, string> = {
  [DependencyType.FS]: 'Finish-to-Start',
  [DependencyType.SS]: 'Start-to-Start',
  [DependencyType.FF]: 'Finish-to-Finish',
  [DependencyType.SF]: 'Start-to-Finish',
};
export const DEPENDENCY_TYPE_SHORT: Record<number, string> = {
  [DependencyType.FS]: 'FS',
  [DependencyType.SS]: 'SS',
  [DependencyType.FF]: 'FF',
  [DependencyType.SF]: 'SF',
};
